<template>
  <div class="activeClientClass">
    <div class="o-ndividualTable" v-loading="loading">
      <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
        <div class="o-custom-table-container c-common-box-shadow c-radius3 client-list-table-align" v-for="(client,key) in clients" :key="key">
            <div class="o-calls-table c-common-gradient">
                <div class="calls-table-row phonesheet-table-row">
                    <div class="calls-table-cell">
                        <div class="table-td-border-right">
                            <div class="calls-table-cell-inner-table">
                                <div class="o-accordion-subtext o-rowtable-text">
                                    <span>Subdomain:
                                        <el-tooltip class="item" effect="dark" content="Click to Copy Client Id" placement="top-start">
                                            <a @click.stop="copyText(''+client.id, 'id')"><i class="fa fa-paste"></i></a>
                                        </el-tooltip>
                                    </span>
                                    <div>
                                        {{client.subdomain}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="calls-table-cell">
                        <div class="table-td-border-right">
                            <div class="calls-table-cell-inner-table">
                                <div class="o-accordion-subtext o-rowtable-text">
                                    <span>Client:</span>
                                    <div>{{client.user?client.user.display_name:'--'}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="calls-table-cell">
                        <div class="table-td-border-right">
                            <div class="o-accordion-subtext o-rowtable-text">
                                <span>Contact Person:</span>
                                <div>{{client.contact_person}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="calls-table-cell">
                        <div class="table-td-border-right">
                            <div class="calls-table-cell-inner-table">
                                <div class="o-accordion-subtext o-rowtable-text">
                                    <span>Phone:</span>
                                    <div>
                                        <!-- <a class="phone-number-display" @click.stop="copyText(''+client.contact_phone,'phone')"> -->

                                        <a :href="'tel:'+getClientContactFormat(client.contact_phone)" class="phone-number-display">
                                            {{ client.contact_phone ? getClientContactFormat(client.contact_phone) : '' }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="calls-table-cell">
                        <div class="table-td-border-right">
                            <div class="calls-table-cell-inner-table">
                                <div class="o-accordion-subtext o-rowtable-text">
                                    <span>Email ID:</span>
                                    <div>{{client.user?client.user.email:'--'}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="calls-table-cell">
                        <div class="table-td-border-right">
                            <div class="o-accordion-subtext o-rowtable-text">
                                <span>Users:</span>
                                <div>{{client.count+'/'+(client.max_user == 999999?'Unlimited':client.max_user)}}</div>
                                <!-- <div>{{client.client_employees.length+"/"+(client.max_user == 999999?'Unlimited':client.max_user)}}</div> -->
                            </div>
                        </div>
                    </div>
                    <div class="calls-table-cell">
                        <div class="table-td-border-right">
                            <div class="o-accordion-subtext o-rowtable-text">
                                <span>Sign up:</span>
                                <div>{{client.created_at?client.created_at:'--'}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="calls-table-cell">
                        <div class="">
                            <div class="o-accordion-subtext o-rowtable-text">
                                <span>Notes:</span>
                                <div>{{client.note}}</div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="calls-table-cell">
                        <div class="">
                            <div class="o-accordion-subtext o-rowtable-text text-center">
                                <a :href="getRedirectUrl(client.subdomain, client.user?client.user.id:'')" target="_blank" class="o-client-view"><i class="fa fa-eye" aria-hidden="true"></i></a>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>

            <div class="o-table-extend-area u-pad-all-5 text-left o-table-extend-area--superadmin">
                <ul class="o-table-extend">
                    <li>
                        <a :href="getRedirectUrl(client.subdomain, client.user?client.user.id:'')" target="_blank" class="o-super-edit-icon">
                            <i class="fa fa-eye" aria-hidden="true"></i> View
                        </a>
                    </li>
                    <li>
                        <a href="javascript: void(0)" @click="editClient(client)" class="o-super-edit-icon">
                            <i class="fa fa-pencil" aria-hidden="true"></i> Edit
                        </a>
                    </li>
                    <li>
                        <a href="javascript: void(0)" @click="goToManageEx(client)" class="o-super-manage-icon">
                            <i class="fa fa-server" aria-hidden="true"></i> Manage Exceptions
                        </a>
                    </li>
                    <li>
                        <a href="javascript: void(0)" @click="deactivate(client.id,key)" class="o-super-deactive-icon">
                            <i class="fa fa-eye-slash" aria-hidden="true"></i> Deactivate
                        </a>
                    </li>
                    <!-- <li>
                        <a @click="deleteClient(client.id,key)" class="o-super-delete-icon">
                            <i class="fa fa-trash" aria-hidden="true"></i> Delete
                        </a>
                    </li> -->
                </ul>
            </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';
    import {
        global
    } from '../../global.js';

    export default {

        computed: {
            ...mapGetters({
                userToken: 'userToken'

            })
        },
        props: ['myProp'],
        watch: {
            myProp: function(newVal) {
                if (newVal == "") {
                    this.getClientList();
                } else {
                    if (newVal.length > 3) {
                        service.get('client/searchClient', {
                                'Authorization': this.userToken,

                                'searchClient': newVal
                            })
                            .then((res) => {
                                this.searchData = res.data.result;

                                this.clients = [];
                                for (var i = 0; i < this.searchData.length; i++) {
                                    if (this.searchData[i].is_active == 1) {
                                        this.clients.push(this.searchData[i]);

                                    }


                                }
                            }).catch((err) => {
                                console.log(err);
                            })
                    }
                }
            }
        },
        data() {
            return {
                loading:false,
                clients: [],
                next_page_url: null,
                savedClients: [],
                searchData: ''
            }
        },
        methods: {
            getClientContactFormat(phone) {
                // phone = phone.replace(/-/g, "");
                // phone = phone.replace(/ /g, "");
                // phone = phone.replace("(", "");
                // phone = phone.replace(")", "");
                let result = '';
                if(phone&&phone.length==10) { 
                    result = '+1'+phone;
                }else if(phone&&phone.length==11) {
                    result = '+' + phone;
                }else if(phone&&phone.length) {
                    result = phone;
                }else {
                    result = '';
                }
                return result;
            },
            loadMore() {
                var arr = this.clients;
                if (this.savedClients.length != 0) {
                    this.savedClients.forEach(function(entry) {
                        arr.push(entry);
                    })

                    if (this.next_page != null) {
                        service.get('client', {
                                'Authorization': this.userToken
                            })
                            .then((newClients) => {
                                this.savedClients = newClients.data.result.data;
                                this.next_page_url = newClients.data.result.next_page_url;

                            }).catch((err) => {
                                console.log(err);
                            });
                    }
                } else
                    this.savedEmployees = [];
            },
            copyText(text,type){
                if(type =='phone') {
                    if(text.length == 10) {
                        text = '+1'+text;
                    }else if(text.length==1){
                        text = '+'+text
                    }
                }
                var textarea = document.createElement("textarea");
		        textarea.textContent = text;
		        textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
		        document.body.appendChild(textarea);
		        textarea.select();
		        try {
		        	// console.log(textarea);
		            document.execCommand("copy");  // Security exception may be thrown by some browsers.
		            this.$notify({
                        title: 'Success',
                        message: 'Copied to clipboard.',
                        type: 'success'
                    });
                    
		        } catch (ex) {
		            console.warn("Copy to clipboard failed.", ex);
		            return false;
		        } finally {
		            document.body.removeChild(textarea);
		        }
            },
            editClient(client) {
                this.$store.dispatch('setClient', {
                    'id': client.id

                });
                this.$router.push({
                    'path': '/editClient'
                });
            },
            goToManageEx(client) {
                this.$store.dispatch('setClient', {
                    'id': client.id

                });
                this.$router.push({
                    'path': '/manageExceptions'
                });
            },
            deleteClient(id, key) {
                this.$confirm('This will permanently delete the client. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.del('client/' + id, {
                            'Authorization': this.userToken
                        })
                        .then((res) => {
                            this.$notify({
                                title: 'Success',
                                message: 'Client Deleted Successfully.',
                                type: 'success'
                            });
                            this.clients.splice(key, 1);
                            this.$router.push({
                                'path': '/clientList'
                            });
                        }).catch((err) => {
                            console.log(err);
                        });
                    //console.log(id);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },
            deactivate(id, key) {
                this.$confirm('This will deactivate the selected client. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.post('client/' + id + "/changeStatus", {
                            status: 0
                        }, {
                            'Authorization': this.userToken
                        })
                        .then((res) => {
                            this.$notify({
                                title: 'Success',
                                message: 'Client Deactivated Successfully.',
                                type: 'success'
                            });
                            this.clients.splice(key, 1);

                        }).catch((err) => {
                            console.log(err);
                        });
                    //console.log(id);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Deactivation cancelled'
                    });
                });
            },
            getClientList() {
                this.$Progress.start();
                this.loading=true;
                service.get('client', {
                    'Authorization': this.userToken
                })
                .then((res) => {
                    this.$Progress.finish();
                    // console.log(res);
                    this.clients = res.data.result;
                    this.next_page_url = res.data.result.next_page_url;
                    this.loading=false;
                    if (res.data.result.next_page_url != null) {
                        service.get('client', {
                                'Authorization': this.userToken
                            })
                            .then((newClients) => {
                                this.savedClients = newClients.data.result;
                                this.next_page_url = null;
                                
                                // this.savedClients = newClients.data.result.data;
                                // this.next_page_url = newClients.data.result.next_page_url;
                            }).catch((err) => {
                                console.log(err);
                            });
                    }

                }).catch((err) => {
                    console.log(err);
                });
            },
            getRedirectUrl(subdomain , clientId){
                let url="https://"+subdomain+"."+global[0].CLIENT_BASE+"#/login/client/"+btoa(clientId)+"/"+btoa(this.userToken);
                if(window.location.hostname == "localhost") {
                    url=window.location.href.split('#')[0]+"#/login/client/"+btoa(clientId)+"/"+btoa(this.userToken);
                }
                return url;
            },
            goToLogin(subdomain , clientId) {
                this.$Progress.start();
                service.get('universal_login', {
                    'Authorization': this.userToken,
                    'userid': clientId,
                    'url': "http://" + subdomain + "." + global[0].CLIENT_BASE,
                })
                .then((res) => {
                    // console.log(res);
                    if (res.data.status_code != 1) {
                        this.$Progress.fail();
                        //this.credential_err = "Invalid Login Credentials";
                        //console.log('incorrect');
                    } else {
                        // console.log('correct', res);
                        let result = res.data.result
                        this.$store.dispatch('userSession', result);
                        this.$cookies.set("csLogin", result.role.slug, "23h");
                        this.$cookies.set("date_format", result.user.employees[0].date_format, "23h");
                        this.$cookies.set("time_format", result.user.employees[0].time_format, "23h");
                        //console.log('timezone', res.data.user.employees[0].client[0].clients.timezone);
                        //this.credential_err = "";
                        this.$Progress.finish();
                        $('.wrapper').css('margin-left', '60px');
                        if (result.role.slug != "super-admin") {
                            this.$cookies.set("time_zone", result.user.employees[0].client[0].clients.timezone, "23h");
                            var notifyType = (result.user.employees[0].email_notification == 1) ? 'email' : 'sms';
                            this.$store.dispatch('setNotificationType', notifyType);
                            this.$store.dispatch('setClientdata', result.user.employees[0].client[0].clients);
                            //var temp={'parent': 'Myjob', 'child': 'Myjob'};
                            // this.$store.dispatch('setSelectedJobFilter', {'parent': 'Myjob', 'child': 'Myjob'});
                            location.reload(true);
                            if (result.role.slug == "client-admin" || result.role.slug == "power-user" && result.user.employees[0].client.length>0) {
                                this.$router.push({
                                    path: "/jobList"
                                });
                            } else {
                                this.$router.push({
                                    path: "/schedule/"+btoa(this.employeeId),
                                });
                            }

                        } else {
                            location.reload(true);
                            this.$router.push({
                                path: "/clientList"
                            });
                        }

                    }
                    //window.location.href = "http://" + subdomain + "." + global[0].CLIENT_BASE;
                }).catch((err) => {
                    console.log(err);
                });
                //return "http://" + subdomain + "." + global[0].CLIENT_BASE;
            }
        },
        mounted() {
            //alert('created');
            $('.loginVue').parent('.wrapper').css('margin-left', '0');
        },
        created() {
            this.getClientList();
        }
    }

</script>
<style scoped>
.phone-number-display{
    padding: 5px;
    cursor: pointer;
    color: #222222;
    text-decoration: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/superAdmin/activeClient.vue